"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const config_1 = __importDefault(require("next/config"));
const pino_1 = __importDefault(require("pino"));
const BrowserConsoleWriter_1 = require("../helpers/log/BrowserConsoleWriter");
const LogHelper_1 = __importDefault(require("../helpers/log/LogHelper"));
const StringHelper_1 = require("../helpers/objects/StringHelper");
const prettyPrintTransport_1 = __importDefault(require("../pino/transports/prettyPrintTransport"));
class ClientLogProvider {
    constructor() {
        var _a, _b, _c, _d;
        const appConfig = (0, config_1.default)();
        this.logLevelApp = (_b = (_a = appConfig === null || appConfig === void 0 ? void 0 : appConfig.publicRuntimeConfig) === null || _a === void 0 ? void 0 : _a.logLevelApp) !== null && _b !== void 0 ? _b : 'silent';
        const prettyPrint = ((_c = appConfig === null || appConfig === void 0 ? void 0 : appConfig.publicRuntimeConfig) === null || _c === void 0 ? void 0 : _c.prettyPrint) === 'true';
        this.appLogOverrides = (0, StringHelper_1.keyValueStringToObject)((_d = appConfig === null || appConfig === void 0 ? void 0 : appConfig.publicRuntimeConfig) === null || _d === void 0 ? void 0 : _d.logLevelAppOverrides);
        this.rootLog = (0, pino_1.default)({
            level: this.logLevelApp,
            browser: {
                asObject: !prettyPrint,
                write: prettyPrint ? (0, BrowserConsoleWriter_1.standardBrowserConsoleWriter)(console) : undefined
            },
            transport: prettyPrint ? (0, prettyPrintTransport_1.default)() : undefined
        });
    }
    getAppLog(module, options) {
        const name = LogHelper_1.default.getLogName(module);
        const childLevel = LogHelper_1.default.validateLogLevel(name, this.appLogOverrides[name]);
        if (childLevel) {
            this.rootLog.warn('Setting log level to %s for: %s ', childLevel, name);
        }
        return this.rootLog.child(
        // the process id is already in the log base if pretty print is not enabled
        { name }, Object.assign(Object.assign({}, options), { level: childLevel !== null && childLevel !== void 0 ? childLevel : this.logLevelApp }));
    }
}
exports.default = ClientLogProvider;
//# sourceMappingURL=clientLog.js.map